import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../redux/hooks';
import CoachPageLayout from '../CoachPageLayout/CoachPageLayout';
import { clearClientSecret } from '../../redux/subscription/subscriptionSlice';
import { SUBSCRIPTION_PLANS } from '../../utils/routes';
import { SubscriptionPlanTypes } from '../../types/coach';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!, {});

function Checkout() {
  const navigate = useNavigate();
  const { clientSecret, createCheckoutSessionLoading, createCheckoutSessionFailed } =
    useAppSelector((state) => state.subscription);
  const { subscriptionPlanName } = useAppSelector((state) => state.coach.coach);
  const dispatch = useDispatch();

  useEffect(() => {
    if (subscriptionPlanName === SubscriptionPlanTypes.PREMIUM) {
      navigate(SUBSCRIPTION_PLANS, { replace: true });
    }
    if (!subscriptionPlanName) {
      navigate(SUBSCRIPTION_PLANS, { replace: true });
    }
  }, []);

  useEffect(() => {
    if (!createCheckoutSessionLoading && createCheckoutSessionFailed) {
      navigate(SUBSCRIPTION_PLANS, { replace: true });
    }
  }, [createCheckoutSessionLoading, createCheckoutSessionFailed]);

  useEffect(
    () => () => {
      dispatch(clearClientSecret());
    },
    []
  );

  return (
    <CoachPageLayout>
      <Grid
        alignItems="center"
        width="100%"
        height="100%"
        sx={{
          background: '#fff',
          maxHeight: '90vh',
          overflow: 'auto',
          flexDirection: 'row',
          py: '15px',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          borderRadius: '10px',
          border: '1px solid #FFDDC840',
        }}
      >
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{ clientSecret }}
          i18nIsDynamicList
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </Grid>
    </CoachPageLayout>
  );
}

export default Checkout;
